
import axios from "axios";
import { base_url } from "../../utils/baseUrl";
const baseURL = `${base_url}tailer-made`; // change if needed

// GET ALL
const getTailorMades = async () => {
    const res = await axios.get(`${baseURL}/getAll`);
    return res.data;
};

// CREATE
const createTailorMade = async (data) => {
    const res = await axios.post(baseURL, data);
    return res.data;
};

// GET SINGLE
const getTailorMade = async (id) => {
    const res = await axios.get(`${baseURL}/${id}`);
    return res.data;
};

// UPDATE
const updateTailorMade = async (id, data) => {
    const res = await axios.put(`${baseURL}/${id}`, data);
    return res.data;
};

// DELETE
const deleteTailorMade = async (id) => {
    const res = await axios.delete(`${baseURL}/${id}`);
    return res.data;
};

// UPDATE STATUS
const updateTailorMadeStatus = async (id) => {
    const res = await axios.put(`${baseURL}/status/${id}`);
    return res.data;
};

// APPROVE QUOTE
const approveQuote = async ({ tailorId, quoteId }) => {
    const res = await axios.patch(`${baseURL}/approve-quote/${tailorId}/${quoteId}`);
    return res.data;
};

const tailorMadeService = {
    getTailorMades,
    createTailorMade,
    getTailorMade,
    updateTailorMade,
    deleteTailorMade,
    updateTailorMadeStatus,
    approveQuote
};

export default tailorMadeService;